module.exports = __webpack_public_path__ + "img/LINE_logo.860ca93a.png";